import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={18.873}
    height="7.05mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9404 13278"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#1c1b17;stroke-width:470.842}.str1{stroke:#2b2a29;stroke-width:332.226}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313102864">
        <path
          d="M2208 6315V2429l2-237 5001-2 3 4441c-116 30-3326 10-3742 10-414 0-851 13-1263-2l-1-324zM697 616c-56 63-122 132-173 206-26 37-133 226-145 236-20 91-60 172-82 268-18 74-10 236-46 290 31 143 11 3603 9 3830v2377c0 278-30 208 272 208h7664c304 0 663-17 961 3 25-165 4-5592 5-6351 0-114-39-331-31-399-25-26 3 24-26-39-6-14-12-38-19-57-15-47-28-72-37-118-82-106-54-181-327-448-214-210-399-244-466-297-370-90-530-76-929-81-1652-23-3359 24-5013 0-462-7-929-54-1329 171-150 85-243 177-288 201zM1936 10215c-3-40-8-84-7-124 1-12 6-45 9-57 8-29 5-20 15-36-29-218 330-581 558-555 88-61 432 3 499 109 62 11 170 118 180 181 172 105 158 574 41 717-44 111-263 325-416 323-46 40-184 46-242 38-27-4-21-4-41-10l-24-11c-129 17-334-135-389-197-94-104-140-213-183-378zm4989 573c-34 28-125 31-177 21l-53-18c-155 34-408-160-510-348-124-230-88-586 16-670l28-48c44-75 119-160 208-198 74-54 379-169 488-83 133-8 277 97 349 169 55 57 71 67 117 143 34 59 72 116 67 187l25 56c23 89 5 162 3 167l-10 26c32 131-105 333-172 396-77 75-218 210-379 200zm-6674-780c22 33 17 122 22 177 13 154 99 382 100 474 40 37 81 152 98 211l236 343c35 41 51 66 90 108 69 74 123 116 209 187 42 35 197 131 211 153l416 189c57-7 201 40 274 51 97 16 196 22 299 22 7 185 2 377 2 563 0 285-32 277 77 470 41 21 51 42 105 62 93 32 1189 21 1265 15 224-65 223-194 223-441 0-220-7-450 1-668l1664-1c12 213 1 453 1 669 0 250 14 378 229 441 86 8 1175 23 1274-20 64-28 66-57 122-80 9-70 44-91 46-218l1-792c302 0 487-77 570-71 34-34 183-83 235-105 90-39 151-85 235-116 20-34 265-181 386-329 57-70 107-129 163-203l138-213c16-46 75-194 111-233-3-53 80-327 94-446 27-228 14-1346 14-1622l-8899 6c-25 309 27 1242-12 1417z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 470.842,
          }}
        />
        <path
          d="M4630 3284c-9 20-241 179-320 258-42 42-65 51-107 91-116 112-341 403-351 412-28 71-78 148-118 230-32 66-73 207-100 240 6 71-35 239-34 353 0 127 50 236 51 315 32 30 15 11 38 47 267 417 389 351 485 466l228 83 81 24c-31-63-57-95-80-159-55-56-169-383-161-481-40-38-36-155-40-220l17-259 44-182c66-173 123-262 221-390 52-69 233-260 312-292l-42 240c-10 134-18 220-2 352 17 136 47 193 76 303l34 54c21 23 21 26 43 53 28 33 4 17 37 37l8-144c21-102 46-170 107-227l110 239c39 72 95 144 121 210 179 247 128 496-30 714-34 50-70 108-104 144l131-38c47-57 254-133 399-384 128-223 148-371 135-658l-26-255-155-415c-38-43-93-198-87-265-35-41-24-130-19-193-108 29-177 109-263 168-24 17 6 1-29 19-44-46-52-56-77-126-44-42-73-206-81-282-8-75 7-313-4-339-35 29-175 100-225 129-79 45-149 98-223 128z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 470.842,
          }}
        />
        <ellipse
          cx={2598}
          cy={10143}
          rx={460}
          ry={516}
          style={{
            strokeWidth: 332.226,
          }}
          className="fill stroke1"
        />
        <ellipse
          cx={6789}
          cy={10143}
          rx={460}
          ry={516}
          style={{
            strokeWidth: 332.226,
          }}
          className="fill stroke1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
